import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { fetchStores } from 'yoda-interfaces/lib/Common/LocationServiceApi';
import { updateUserStoreLocationInfo } from 'yoda-site-components/lib/actions/LocationServiceAction';
import {
    UPDATE_STORE_COOKIE_FROM_PLA_STORE,
    UPDATE_PLA_STORE_ERROR,
} from '../actionTypes/PLAStoreActionTypes';

function* updatePLAStore({ payload }) {
    const { storeId } = payload;
    try {
        if (storeId) {
            const fetchStoreResponse = yield call(fetchStores, storeId);
            const { name = '', zip, city, state, curbside, street, phone, timings } = get(
                fetchStoreResponse,
                'data.stores[0]',
                null
            );
            const inputZipCode = get(fetchStoreResponse, 'data.meta.inputZipCode', null) || zip;
            if (name) {
                yield put(
                    updateUserStoreLocationInfo({
                        id: storeId,
                        name,
                        zip,
                        city,
                        phone,
                        state,
                        street,
                        curbsidePickupIndicator: !isEmpty(curbside),
                        distance: 0,
                        inputZipCode,
                        phone,
                        timings,
                    })
                );
            }
        }
    } catch (error) {
        yield put({
            type: UPDATE_PLA_STORE_ERROR,
            error,
        });
    }
}

const watchPDPPLASToreSaga = function* watchPDPPLASToreSaga() {
    yield takeLatest(UPDATE_STORE_COOKIE_FROM_PLA_STORE, updatePLAStore);
};

watchPDPPLASToreSaga.sagaName = 'pdpPLASToreSaga';

export default watchPDPPLASToreSaga;
